import { startCase } from 'lodash';

export const getFormattedScriptName = (name: string | null) =>
  name ? startCase(name.replaceAll('_', ' ')) : '';
